// Single source of truth for business contact details, used across
// header, footer, forms and CTAs instead of hardcoded strings per file.
export const business = {
  name: "TR Structures",
  legalName: "TR Structures",
  foundedYear: 2019,
  siteUrl: "https://www.trstructures.com",
  phone: {
    display: "+91 80086 48588",
    href: "tel:+918008648588",
  },
  whatsapp: {
    number: "918008648588",
    href: "https://api.whatsapp.com/send?phone=918008648588&text=Hello,%20I%20have%20a%20question%20about%20TR%20Structures",
  },
  email: {
    display: "trstructureshyd@gmail.com",
    href: "mailto:trstructureshyd@gmail.com",
  },
  address: {
    line: "Bibinagar, Yadadri Bhuvanagiri, Telangana 508126",
  },
  hours: "MON - SAT 09:00 - 19:00",
  social: {
    facebook: "https://www.facebook.com/trstructures",
    instagram: "https://www.instagram.com/trstructures/",
    linkedin: "https://www.linkedin.com/company/trstructures/",
    twitter: "https://twitter.com/trstructures",
    youtube: "https://www.youtube.com/@trstructures",
  },
};

export default business;
